import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/pt-br';

dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.locale('pt-br');
dayjs.extend(utc);

export default dayjs;
